import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=64300193&scoped=true&"
import script from "./Change.vue?vue&type=script&lang=ts&"
export * from "./Change.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64300193",
  null
  
)

export default component.exports